"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEEDANCE_SCENE_REGEN_CREDITS = exports.SEEDANCE_VIDEO_AGENT_CREDITS = exports.REPORT_CREDITS = exports.MESSAGE_CREDITS = exports.IMAGE_PLACEMENT_PRICING_VERSION = exports.IMAGE_PLACEMENT_CREDITS = exports.AGENT_STATIC_CREDITS = exports.TRIAL_EXTENSION_CREDITS = exports.FREE_TEST_CREDITS = exports.TRIAL_CREDITS = void 0;
exports.TRIAL_CREDITS = 1000;
/**
 * Granted once at signup, no card required. Deliberately below `SEEDANCE_VIDEO_AGENT_CREDITS` —
 * video generation is not part of the free test, and the balance is what enforces that. Buys roughly
 * ten static ads. Trial and free-test users are also blocked from video by the paid-subscription
 * gate (`VideoGenerationSubscriptionGuard`); balance alone is not the only enforcement.
 */
exports.FREE_TEST_CREDITS = 300;
/**
 * Bonus credits granted once when a user accepts a retention trial-extension cancellation offer.
 * Kept independent of `TRIAL_CREDITS` so signup trial size can change without changing the offer.
 */
exports.TRIAL_EXTENSION_CREDITS = 3000;
exports.AGENT_STATIC_CREDITS = 30;
/** Each additional AI-generated placement or aspect-ratio image has its own lower tariff. */
exports.IMAGE_PLACEMENT_CREDITS = 10;
/** Each price revision requires a fresh per-user acknowledgement. */
exports.IMAGE_PLACEMENT_PRICING_VERSION = 'image-placement-10-2026-10-19';
exports.MESSAGE_CREDITS = 1;
exports.REPORT_CREDITS = 10;
exports.SEEDANCE_VIDEO_AGENT_CREDITS = 500;
exports.SEEDANCE_SCENE_REGEN_CREDITS = 150;
